"use strict";
exports.__esModule = true;
var _1ds_core_js_1 = require("@microsoft/1ds-core-js");
var _1ds_post_js_1 = require("@microsoft/1ds-post-js");
var _1ds_properties_js_1 = require("@microsoft/1ds-properties-js");
var Constants_1 = require("../Constants");
var Environment_1 = require("./upload/Environment");
var ReactNativeMobileDevicePlugin_1 = require("./upload/react-native-mobile/ReactNativeMobileDevicePlugin");
var ReactNativeWindowsDevicePlugin_1 = require("./upload/react-native-windows/ReactNativeWindowsDevicePlugin");
var WWAUploadPlugin_1 = require("./upload/uwp-wwa/WWAUploadPlugin");
var ProviderBase = (function () {
    function ProviderBase(logger, componentName, callerEnforcedXboxOptionalDataConsent, instrumentationKeyOverride, providerGuidOverride, providerGroupGuidOverride, gpcDataSharingOptIn) {
        this.appInsights = new _1ds_core_js_1.AppInsightsCore();
        var channels = [];
        var extensions = [];
        var extensionConfig = [];
        switch (Environment_1.getEnvironment()) {
            case Environment_1.EnvironmentValue.ReactNativeMobile:
                logger.info("Initializing GTLJS as a React-Native Mobile environment.");
                extensions.push(new ReactNativeMobileDevicePlugin_1["default"]((callerEnforcedXboxOptionalDataConsent !== null && callerEnforcedXboxOptionalDataConsent !== void 0 ? callerEnforcedXboxOptionalDataConsent : false)));
                extensions.push(new _1ds_properties_js_1.PropertiesPlugin());
                channels.push([new _1ds_post_js_1.PostChannel()]);
                break;
            case Environment_1.EnvironmentValue.ReactNativeWindows:
                logger.info("Initializing GTLJS as a React-Native Windows environment.");
                this.registeredRnwPlugin = new ReactNativeWindowsDevicePlugin_1["default"](componentName, callerEnforcedXboxOptionalDataConsent, providerGuidOverride, providerGroupGuidOverride);
                channels.push([this.registeredRnwPlugin]);
                break;
            case Environment_1.EnvironmentValue.WWA:
                logger.info("Initializing GTLJS as a Windows-UWP environment.");
                channels.push([new WWAUploadPlugin_1["default"](componentName)]);
                break;
            case Environment_1.EnvironmentValue.NodeJs:
                logger.info("Initializing GTLJS as a node.js environment.");
                var nodeHttpXHROverride = require("./upload/node/NodeXHROverride").nodeHttpXHROverride;
                var postChannelConfig = {
                    httpXHROverride: nodeHttpXHROverride
                };
                var postChannel = new _1ds_post_js_1.PostChannel();
                extensionConfig[postChannel.identifier] = postChannelConfig;
                extensions.push(new _1ds_properties_js_1.PropertiesPlugin());
                channels.push([postChannel]);
                break;
            case Environment_1.EnvironmentValue.Browser:
                logger.info("Initializing GTLJS as a Browser environment.");
                var propertiesPlugin = new _1ds_properties_js_1.PropertiesPlugin();
                extensionConfig[propertiesPlugin.identifier] = {
                    gpcDataSharingOptIn: (gpcDataSharingOptIn !== null && gpcDataSharingOptIn !== void 0 ? gpcDataSharingOptIn : false)
                };
                extensions.push(propertiesPlugin);
                channels.push([new _1ds_post_js_1.PostChannel()]);
                break;
            default:
                throw new Error("Unsupported PlatformValue detected.");
                break;
        }
        var instrumentationKey = (instrumentationKeyOverride !== null && instrumentationKeyOverride !== void 0 ? instrumentationKeyOverride : Constants_1.GTL_SHARED_INSTRUMENTATION_KEY);
        var insightsConfig = {
            channels: channels,
            extensions: extensions,
            instrumentationKey: instrumentationKey,
            extensionConfig: extensionConfig
        };
        this.appInsights.initialize(insightsConfig, []);
    }
    ProviderBase.prototype.Unregister = function () {
        if (this.registeredRnwPlugin) {
            this.registeredRnwPlugin.Unregister();
            this.registeredRnwPlugin = undefined;
        }
    };
    ProviderBase.prototype.Write = function (event) {
        this.appInsights.track(event);
    };
    return ProviderBase;
}());
exports.ProviderBase = ProviderBase;
//# sourceMappingURL=ProviderBase.js.map